module.exports = __webpack_public_path__ + "static/media/hint.20945db3.ogg";